module.exports = __webpack_public_path__ + "img/logo-text-right.f0e1c293.png";